import { Injectable } from '@angular/core';
import { HttpClient , HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProductBlockService {

  constructor(protected http: HttpClient) { }

  blockProduct(apikey: string, hash: string): Observable<any> {
    console.log(`Bloquear producto ${hash}`);
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
      headers = headers.append('accept', 'application/json'); 
      headers = headers.append('xApiKeyPublic', apikey);
    return this.http.post<any>(environment.urlApi + '/producto/' + hash + '/bloqueo-temporal', '' ,{headers});    
  }
}